import React from "react";

const AccountDeletionPagePA = () => {
  const steps = [
    { number: "1", icon: "📱", label: "Open the app" },
    { number: "2", icon: "👤", label: "Go to Profile / Settings" },
    { number: "3", icon: "🗑️", label: 'Tap "Delete Account"' },
    { number: "4", icon: "✅", label: "Confirm deletion" },
  ];

  const deletedData = [
    { icon: "🔐", label: "User authentication data (Cognito account)" },
    { icon: "👤", label: "Profile information" },
    { icon: "💾", label: "Stored app data" },
    { icon: "📊", label: "Usage-related data" },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Banner */}
      <div className="bg-gradient-to-r from-red-600 to-red-400 py-14 px-4 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3">
          Account Deletion
        </h1>
        <p className="text-red-100 text-base sm:text-lg font-medium">
          Our Panchangam App
        </p>
      </div>

      {/* Main Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-10">

        {/* Intro */}
        <div>
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
            <strong>Our Panchangam App</strong> allows users to delete their account
            directly inside the app. This action is <strong>permanent</strong> and
            cannot be undone.
          </p>
        </div>

        <hr className="border-gray-200" />

        {/* How to Delete */}
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-6">
            How to Delete Your Account
          </h2>

          <div className="space-y-4">
            {steps.map((step) => (
              <div key={step.number} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">
                  {step.number}
                </div>
                <div className="flex items-center gap-2 pt-1">
                  <span className="text-lg">{step.icon}</span>
                  <p className="text-gray-700 text-base">{step.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <hr className="border-gray-200" />

        {/* Data Deleted */}
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
            Data Permanently Deleted
          </h2>
          <p className="text-gray-600 text-base mb-5">
            When you delete your account, the following data will be permanently removed:
          </p>

          <div className="space-y-3">
            {deletedData.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <span className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></span>
                <span className="text-lg flex-shrink-0">{item.icon}</span>
                <p className="text-gray-700 text-base">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        <hr className="border-gray-200" />

        {/* Timeline */}
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
            ⏳ Data Removal Timeline
          </h2>
          <p className="text-gray-700 text-base leading-relaxed">
            All data will be{" "}
            <strong className="text-red-600">permanently removed within 30 days</strong>{" "}
            of your deletion request.
          </p>
        </div>

        <hr className="border-gray-200" />

        {/* Contact */}
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
            📧 Need Assistance?
          </h2>
          <p className="text-gray-600 text-base mb-2">
            If you face any issues deleting your account, contact us at:
          </p>
          <a
            href="mailto:projects@datadna.in"
            className="text-red-600 hover:text-red-800 underline font-semibold text-base"
          >
            projects@datadna.in
          </a>
        </div>

        <hr className="border-gray-200" />

        {/* Footer */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
            <div className="bg-blue-50  p-6 text-center border">
            <p className="text-gray-500 text-sm">
                © {new Date().getFullYear()} DATADNA · Our Panchangam App · All rights reserved.
            </p>
            </div>
        </div>

      </div>
    </div>
  );
};

export default AccountDeletionPagePA;
